import React, { Component } from 'react'
import SubscriptionComponent from '../../Payment/Subscription/SubscriptionComponent'
import CreateComponent from '../../Payment/Subscription/Button/CreateComponent'
import CancelComponent from '../../Payment/Subscription/Button/CancelComponent'
import UpdateComponent from '../../Payment/Subscription/Button/UpdateComponent'
import { Button } from 'semantic-ui-react'
/**
 * Monthly subscription component for Android devices.
 */
export default class MonthlyComponent extends Component {
  render() {
    const { planId, subscription, callback } = this.props

    let subscriptionId = null

    if (subscription !== null && subscription.hasOwnProperty('id')) {
      subscriptionId = subscription.id
    }

    const cancelButton = (
      <CancelComponent subscriptionId={subscriptionId} callback={callback}>
        <Button
          color="grey"
          content="Unsubscribe"
          icon="remove circle"
          size="tiny"
          style={{ margin: '13px' }}
        />
      </CancelComponent>
    )

    const updateButton = (
      <UpdateComponent
        header="$40 / month"
        subscriptionId={subscriptionId}
        planId={planId}
        callback={callback}
      >
        {({ onOpen }) => (
          <Button
            onClick={onOpen}
            color="purple"
            content="$40 / month"
            icon="cart"
            label={{
              basic: true,
              color: 'purple',
              pointing: 'left',
              content: 'Update subscription',
            }}
            size="massive"
          />
        )}
      </UpdateComponent>
    )

    const createButton = (
      <CreateComponent planId={planId} callback={callback} header="$40 / month">
        <Button
          color="purple"
          content="$40 / month"
          icon="cart"
          label={{
            basic: true,
            color: 'purple',
            pointing: 'left',
            content: 'Purchase subscription',
          }}
          size="massive"
        />
      </CreateComponent>
    )

    return (
      <div>
        <SubscriptionComponent
          planId={planId}
          subscription={subscription}
          cancelButton={cancelButton}
          createButton={createButton}
          updateButton={updateButton}
        />
      </div>
    )
  }
}
